// ============================================================
// home-search/backend-banner.js — Banner de estado del backend
// ============================================================

import { getApiBaseUrl } from '../api-config.js';

let backendBanner;

function ensureBackendBanner() {
  if (backendBanner) return backendBanner;

  backendBanner = document.createElement('div');
  backendBanner.id = 'backend-status-banner';
  backendBanner.style.cssText = `
    position: fixed; left: 50%; transform: translateX(-50%);
    bottom: 24px; z-index: 10001; max-width: 92vw;
    background: #fef2f2; color: #991b1b; border: 1px solid #fecaca;
    box-shadow: 0 10px 30px rgba(0,0,0,0.12); border-radius: 12px;
    padding: 12px 14px; display: none; align-items: center; gap: 10px;
  `;

  const icon = document.createElement('i');
  icon.className = 'fa fa-triangle-exclamation';

  const text = document.createElement('span');
  text.id = 'backend-status-text';
  text.textContent = 'No se pudo conectar con el servidor.';

  const link = document.createElement('a');
  link.id = 'backend-status-link';
  link.href = '#';
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  link.style.cssText = 'color:#1d4ed8;font-weight:600;text-decoration:underline;';
  link.textContent = 'Probar backend';

  const btnClose = document.createElement('button');
  btnClose.id = 'backend-status-close';
  btnClose.type = 'button';
  btnClose.style.cssText = 'margin-left:auto;background:#ef4444;color:#fff;border:none;border-radius:8px;padding:6px 10px;cursor:pointer;';
  btnClose.textContent = 'Cerrar';

  backendBanner.appendChild(icon);
  backendBanner.appendChild(text);
  backendBanner.appendChild(link);
  backendBanner.appendChild(btnClose);

  document.body.appendChild(backendBanner);
  btnClose.addEventListener('click', () => { backendBanner.style.display = 'none'; });
  return backendBanner;
}

async function showBackendWarning(message) {
  const banner = ensureBackendBanner();
  const text = document.getElementById('backend-status-text');
  const link = document.getElementById('backend-status-link');
  text.textContent = message || 'No se pudo conectar con el servidor.';
  link.href = `${getApiBaseUrl()}/health`;
  banner.style.display = 'flex';
}

/**
 * Prueba la conexión al backend y muestra el banner si falla
 * @returns {Promise<boolean>} true si el backend responde
 */
export async function testBackend() {
  try {
    const res = await fetch(`${getApiBaseUrl()}/health`, { cache: 'no-store' });
    if (!res.ok) throw new Error('Health no OK');
    ensureBackendBanner().style.display = 'none';
    return true;
  } catch (e) {
    await showBackendWarning('No se pudo contactar al backend. Revisa que esté corriendo en :3000.');
    return false;
  }
}
